import React from 'react';
import styled from '@emotion/styled';
import { FormattedDate } from '@css-xp/base';
import { NEW_DESIGN_DATE_FORMAT } from '@atlassian/cssxp-typescommon';
import { EntitlementDetails, BillingStatus } from '@css-xp/graphtypes/src/generated-types-new';
import { N500, N0 } from '@atlaskit/theme/colors';

const BannerContentWrapper = styled.div<{ shouldTakeFullWidth?: boolean }>`
  background-color: ${N500};
  padding: 8px 0 8px 50px;
  font-weight: 400;
  color: ${N0};
  ${(props) => props.shouldTakeFullWidth && `margin-left: -30px;`}
  ${(props) => props.shouldTakeFullWidth && `margin-right: -32px;`}
  .banner-message {
    ${(props) => props.shouldTakeFullWidth && `margin-left: -30px;`}
  }
`;

export const EntitlementBanner = ({
  pauseBilling,
  billingStatus,
  isDesignIteration1Enabled,
}: { isDesignIteration1Enabled?: boolean } & Pick<EntitlementDetails, 'pauseBilling' | 'billingStatus'>) => {
  const isEntitlementInGracePeriod = pauseBilling?.startTimestamp;

  if (billingStatus === BillingStatus.ACTIVE && isEntitlementInGracePeriod) {
    return (
      <div>
        <BannerContentWrapper shouldTakeFullWidth={isDesignIteration1Enabled}>
          <span className="banner-message">This entitlement is currently in grace period from</span>{' '}
          <FormattedDate format={NEW_DESIGN_DATE_FORMAT} date={pauseBilling?.startTimestamp?.toString()} />
          <span>&nbsp;until&nbsp;</span>
          <FormattedDate format={NEW_DESIGN_DATE_FORMAT} date={pauseBilling?.endTimestamp?.toString()} />
        </BannerContentWrapper>
      </div>
    );
  }
  return null;
};
